// src/state/register/orders/types.ts
var ETransactionTypes = /* @__PURE__ */ ((ETransactionTypes2) => {
  ETransactionTypes2["AUTH"] = "auth";
  ETransactionTypes2["CAPTURE"] = "capture";
  ETransactionTypes2["SALE"] = "sale";
  ETransactionTypes2["REFUND"] = "refund";
  ETransactionTypes2["VOID"] = "void";
  ETransactionTypes2["TIP_ADJUST"] = "tip_adjust";
  ETransactionTypes2["ABORT"] = "abort";
  return ETransactionTypes2;
})(ETransactionTypes || {});
var EPaymentMethod = /* @__PURE__ */ ((EPaymentMethod2) => {
  EPaymentMethod2["CASH"] = "cash";
  EPaymentMethod2["CREDIT_CARD"] = "creditCard";
  EPaymentMethod2["GIFT_CARD"] = "giftCard";
  EPaymentMethod2["HOUSE"] = "houseTender";
  EPaymentMethod2["MOBILE"] = "mobile";
  EPaymentMethod2["REFUND"] = "refund";
  EPaymentMethod2["CUSTOM_TENDER"] = "customTender";
  return EPaymentMethod2;
})(EPaymentMethod || {});
var EPaymentStatus = /* @__PURE__ */ ((EPaymentStatus2) => {
  EPaymentStatus2["APPROVED"] = "approved";
  EPaymentStatus2["BATCHED"] = "batched";
  EPaymentStatus2["REFUNDED"] = "refunded";
  EPaymentStatus2["VOIDED"] = "voided";
  EPaymentStatus2["AUTH_VOIDED"] = "auth-voided";
  EPaymentStatus2["AUTH"] = "auth";
  EPaymentStatus2["PARTIAL_VOIDED"] = "partial-voided";
  EPaymentStatus2["PARTIAL_REFUNDED"] = "partial-refunded";
  return EPaymentStatus2;
})(EPaymentStatus || {});
var ECheckStatus = /* @__PURE__ */ ((ECheckStatus2) => {
  ECheckStatus2["OPEN"] = "open";
  ECheckStatus2["PARTIALLY_PAID"] = "partiallyPaid";
  ECheckStatus2["PAID"] = "paid";
  ECheckStatus2["CLOSED"] = "closed";
  ECheckStatus2["VOIDED"] = "voided";
  return ECheckStatus2;
})(ECheckStatus || {});
var PricingMode = /* @__PURE__ */ ((PricingMode2) => {
  PricingMode2["INCLUDED"] = "included";
  PricingMode2["ADDITIONAL"] = "additional";
  return PricingMode2;
})(PricingMode || {});
var OrderStatus = /* @__PURE__ */ ((OrderStatus2) => {
  OrderStatus2["OPEN_INITIATED"] = "open-initiated";
  OrderStatus2["OPEN_ORDERED"] = "open-ordered";
  OrderStatus2["TIP_PENDING"] = "tip-pending";
  OrderStatus2["FAILED"] = "failed";
  OrderStatus2["CLOSED_BATCH_PENDING"] = "closed-batch pending";
  OrderStatus2["CLOSED_COMPLETE"] = "closed-complete";
  OrderStatus2["OTHER_READY_FOR_PICKUP"] = "other-ready for pickup";
  OrderStatus2["OTHER_ON_THE_WAY"] = "other-on the way";
  OrderStatus2["OTHER_VOIDED"] = "other-voided";
  return OrderStatus2;
})(OrderStatus || {});
var OrderType = /* @__PURE__ */ ((OrderType2) => {
  OrderType2["DINE_IN"] = "dine in";
  OrderType2["CATERING"] = "catering";
  OrderType2["DELIVERY"] = "delivery";
  OrderType2["TO_GO"] = "to_go";
  return OrderType2;
})(OrderType || {});

export { ECheckStatus, EPaymentMethod, EPaymentStatus, ETransactionTypes, OrderStatus, OrderType, PricingMode };
